import { SecondDoorContentContainer } from 'shared/containers/SecondDoorContentContainer';
import { FirstDoorContentContainer } from 'shared/containers/FirstDoorContentContainer';
import { ThirdDoorContentContainer } from 'shared/containers/ThirdDoorContentContainer';
import { FourthDoorContentContainer } from 'shared/containers/FourthDoorContentContainer';
import { FifthDoorContentContainer } from 'shared/containers/FifthDoorContentContainer';
import { SixDoorContentContainer } from 'shared/containers/SixDoorContentContainer';
import { SeventhDoorContentContainer } from 'shared/containers/SeventhDoorContentContainer';
import { EighthDoorContentContainer } from 'shared/containers/EighthDoorContentContainer';

export const ALL_DOORS = [
  {
    id: 1,
    date: '2025-12-08',
    image: 'first',
    title: 'Приветствуем вас в нашем новогоднем адвенте!',
    Content: FirstDoorContentContainer,
  },
  {
    id: 2,
    date: '2025-12-10',
    image: 'second',
    title: 'Второе окошко открыто!',
    Content: SecondDoorContentContainer,
  },
  {
    id: 3,
    date: '2025-12-15',
    image: 'third',
    title: 'Третье окошко открыто!',
    Content: ThirdDoorContentContainer,
  },
  {
    id: 4,
    date: '2025-12-17',
    image: 'fourth',
    title: 'Четвертое окошко открыто!',
    Content: FourthDoorContentContainer,
  },
  {
    id: 5,
    date: '2025-12-22',
    image: 'fifth',
    title: 'Пятое окошко открыто!',
    Content: FifthDoorContentContainer,
  },
  {
    id: 6,
    date: '2025-12-24',
    image: 'sixth',
    title: 'Шестое окошко открыто!',
    Content: SixDoorContentContainer,
  },
  {
    id: 7,
    date: '2025-12-26',
    image: 'seventh',
    title: 'Открываем седьмое окошко. В нем — особенный сюрприз 💙',
    Content: SeventhDoorContentContainer,
  },
  {
    id: 8,
    date: '2025-12-29',
    image: 'eighth',
    title: 'С Наступающим Новым годом!',
    Content: EighthDoorContentContainer,
  },
];
